import { Row, Space } from "@stenajs-webui/core";
import type { FC, ReactElement, ReactNode } from "react";
import { components, type OptionProps } from "react-select";

import { SailingCategoryDotWithText } from "../../common-ui/sailing-category/SailingCategoryDotWithText";
import type {
  Sailing,
  Sailing_sailingType,
} from "../graphql/fragments/gql/Sailing";
import type { DropdownOption } from "../utils/optionTransformers";

export interface DepartureTimeWithSailingTypeProps {
  children?: ReactNode;
  sailingType: Sailing_sailingType;
}

const DepartureTimeWithSailingType: FC<DepartureTimeWithSailingTypeProps> = ({
  children,
  sailingType,
}) => {
  return (
    <Row alignItems="center">
      <Row width={"3em"}>{children}</Row>
      <Space />
      <SailingCategoryDotWithText type={sailingType} />
    </Row>
  );
};

export const DepartureTimeDropdownOption = ({
  children,
  ...optionProps
}: OptionProps<DropdownOption<Sailing>, false>): ReactElement => (
  <components.Option {...optionProps}>
    <DepartureTimeWithSailingType
      sailingType={optionProps.data.data.sailingType}
    >
      {children}
    </DepartureTimeWithSailingType>
  </components.Option>
);
